import * as d3 from 'd3';
import $ from 'jquery';

const VIEWBOX_SIZE = 600;

const angleModifier = () => Math.min(0.6, Math.random());
const randomRadius = (min, max) => Math.min(max, Math.max(min, Math.random() * max));

const generatePoints = (size) => {
    const circle = 2 * Math.PI;
    const division = circle / 6;
    const maxRadius = size * 0.45;
    const minRadius = size * 0.3;
    const center = size * 0.5;
    const points = [];

    for (let i = division; i <= circle; i += division) {
        const radius = randomRadius(minRadius, maxRadius);
        const modifier = angleModifier();
        const x = center + (radius * Math.cos(i + modifier));
        const y = center + (radius * Math.sin(i + modifier));
        points.push([x, y]);
    }
    return points;
};

const lineGenerator = d3.line()
    .curve(d3.curveCatmullRomClosed.alpha(0.4))
    .x(d => d[0])
    .y(d => d[1]);

function initBlob($wrapper, index) {
    const $target = $wrapper.find('.blob-container').length ? $wrapper.find('.blob-container') : $wrapper;
    const $img = $target.find('img');
    const imgSrc = $img.attr('src');
    
    if (imgSrc) $img.remove();

    const clipId = `blob-clip-${index}`;

    const svg = d3.select($target[0])
        .append('svg')
        .attr('viewBox', `0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`)
        .attr('preserveAspectRatio', 'xMidYMid meet')
        .attr('class', 'blob-svg-layer');

    const defs = svg.append('defs');
    
    const clipPath = defs.append('clipPath')
        .attr('id', clipId);

    const clipPathShape = clipPath.append('path');

    const path3 = svg.append('path').attr('class', 'blob-border blob-border-3');
    const path2 = svg.append('path').attr('class', 'blob-border blob-border-2');
    const path1 = svg.append('path').attr('class', 'blob-border blob-border-1');

    let svgImage = null;
    if (imgSrc) {
        svgImage = svg.append('image')
            .attr('href', imgSrc)
            .attr('width', VIEWBOX_SIZE)
            .attr('height', VIEWBOX_SIZE)
            .attr('preserveAspectRatio', 'xMidYMid slice')
            .attr('clip-path', `url(#${clipId})`);
    }

    const animatedPaths = svg.selectAll('.blob-border, clipPath path');

    function animate() {
        const newPathData = lineGenerator(generatePoints(VIEWBOX_SIZE));

        animatedPaths.transition()
            .duration(8000)
            .ease(d3.easeCubicInOut)
            .attr('d', newPathData)
            .on('end', function(d, i) {
                if (i === 0) animate();
            });
    }

    const initialPathData = lineGenerator(generatePoints(VIEWBOX_SIZE));
    animatedPaths.attr('d', initialPathData);

    animate();
}

$(document).ready(() => {
    $('.wp-block-pierrelejeune-blob').each(function(index) {
        initBlob($(this), index);
        $(this).addClass('active');
    });
});